import { BaseService } from './BaseService';
import { WeightMilestoneDashboard } from '../models/weight-milestones';

/**
 * `GET /dashboard/weights`, called through `BaseService` rather than the generated client for the same
 * reason `PigletRegistrationService` is: regenerating `src/api/HealthSystemApi.ts` today also pulls in
 * unrelated in-flight backend changes. Swap to the generated client once it is regenerated deliberately.
 */
export class WeightMilestoneService extends BaseService {
  url = '/dashboard/weights';

  /**
   * `farmId` scopes the response to a farm other than the token's own business unit, for the admin farms
   * overview. Omitted, the API answers for the signed-in business unit.
   */
  getDashboard = async (weeks: number, farmId?: string): Promise<WeightMilestoneDashboard> => {
    const query = this.BuildQueryString({ weeks, farmId });
    const result = await this.Fetch(`${this.url}?${query}`, 'GET');
    return this.FromResult<WeightMilestoneDashboard>(result);
  };
}

export default WeightMilestoneService;
